import { CUSTOMER_SEGMENT_OPTIONS } from 'src/constants/regionalPlanApprovals.constants'

export const planType = [
  { label: 'Attached', value: 'ATT' },
  { label: 'Attached NEXT GENERATION', value: 'ATTNG' },
  { label: 'Basement', value: 'BAS' },
  { label: 'Carriage/Coach', value: 'CAR' },
  { label: 'Condominiums', value: 'CON' },
  { label: 'Condominiums NEXT GENERATION', value: 'CONNG' },
  { label: 'Cottages', value: 'COT' },
  { label: 'Crawl', value: 'CRA' },
  { label: 'Custom/Estate Homes', value: 'CUS' },
  { label: 'Detached', value: 'DET' },
  { label: 'Detached NEXT GENERATION', value: 'DETNG' },
  { label: 'Estate Homes', value: 'EST' },
  { label: 'Half Acre Plus Homesite', value: 'HAL' },
  { label: 'Lofts', value: 'LOF' },
  { label: 'Mono Slab Foundation', value: 'MSL' },
  { label: 'Patio Home/Garden Home', value: 'PAT' },
  { label: 'Slab', value: 'SLA' },
  { label: 'Stemwall Foundation', value: 'STE' },
  { label: 'Town Homes', value: 'TOW' },
  { label: 'Town Homes NEXT GENERATION', value: 'TOWNG' },
  { label: 'Tuck Under', value: 'TUC' },
  { label: 'Tuck Under Home Automation', value: 'TUCHA' },
  { label: 'Villas', value: 'VIL' },
]

export const shellType = planType
export const unitType = planType

export const planType_: Record<string, string> = {
  ATT: 'Attached',
  ATTNG: 'Attached NEXT GENERATION',
  BAS: 'Basement',
  CAR: 'Carriage/Coach',
  CON: 'Condominiums',
  CONNG: 'Condominiums NEXT GENERATION',
  COT: 'cottage',
  CRA: 'crawl',
  CUS: 'custom/Estate Homes',
  DET: 'Detached',
  DETNG: 'Detached NEXT GENERATION',
  EST: 'Estate Homes',
  HAL: 'Half Acre Plus Homesite',
  LOF: 'Lofts',
  MSL: 'Mono Slab Foundation',
  PAT: 'Patio Home/Garden Home',
  SLA: 'Slab',
  STE: 'Stemwall Foundation',
  TOW: 'Town Homes',
  TOWNG: 'Town Homes NEXT GENERATION',
  TUC: 'Tuck Under',
  TUCHA: 'Tuck Under Home Automation',
  VIL: 'Villas',
}

export const planStatus = [
  { label: 'Active', value: 'Active' },
  { label: 'Coming Soon', value: 'COM' },
  { label: 'Discontinued for Web only', value: 'DFW' },
  { label: 'Discontinued Sales, Web and JDE', value: 'DIS' },
  { label: 'Discontinued for Web and Sales', value: 'DSL' },
  { label: 'Model', value: 'MDL' },
  {
    label: 'Shell Component of Multi-Fam Do not track to Sale or Web',
    value: 'SHL',
  },
  { label: 'Temporarily Sold Out', value: 'TMP' },
]

export const shellStatus = planStatus

/** LTGC-5711: vocabulary shared with the Approved Regional Plan data feed. */
export const customerSegments = CUSTOMER_SEGMENT_OPTIONS.map((segment) => ({
  label: segment,
  value: segment,
}))
export const unitStatus = planStatus

export const planStatus_: Record<string, string> = {
  Active: 'Active',
  COM: 'Coming Soon',
  DFW: 'Discontinued for Web only',
  DIS: 'Discontinued Sales, Web and JDE',
  DSL: 'Discontinued for Web and Sales',
  MDL: 'Model',
  SHL: 'Shell Component of Multi-Fam Do not track to Sale or Web',
  TMP: 'Temporarily Sold Out',
}

export const structureType: Record<string, string> = {
  carport: 'Carport',
  condominium: 'Condominium',
  garage: 'Garage',
  townhome: 'Townhome',
}

export const foundationType = [
  { label: 'Basement', value: 'BS' },
  { label: 'Condo (Stacked Living)', value: 'CN' },
  { label: 'Crawl Space', value: 'CS' },
  { label: 'Mid/Highrise (Over 4 floors)', value: 'MH' },
  { label: 'Slab', value: 'SL' },
  { label: 'Stem Wall', value: 'SW' },
  { label: 'Walk Out', value: 'WO' },
]

export const foundationType_: Record<string, string> = {
  BS: 'Basement',
  CN: 'Condo (Stacked Living)',
  CS: 'Crawl Space',
  MH: 'Mid/Highrise (Over 4 floors)',
  SL: 'Slab',
  SW: 'Stem Wall',
  WO: 'Walk Out',
}

export const allowedLivingAreas = [0, 1, 2, 3, 4, 5]

export const unitLivingAreas = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
]

export const bedRooms = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
]

export const fullBathrooms = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
]

export const halfBathrooms = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
]
export const floorCeilingFt = Array.from({ length: 16 }, (_, i) => ({
  label: (i + 5).toString(),
  value: i + 5,
}))

export const basements = [
  { label: 'N', value: 'N' },
  { label: 'Y', value: 'Y' },
]

export const yesNo_ = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' },
]

export const trueFalse = [
  { label: 'No', value: 'false' },
  { label: 'Yes', value: 'true' },
]

export const yN = [
  { label: 'No', value: 'N' },
  { label: 'Yes', value: 'Y' },
]

export const basementSelection = [
  { label: 'Finished', value: 'Finished' },
  { label: 'Unfinished', value: 'Unfinished' },
]

export const stories = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
]

export const additionalRooms_ = [
  'Additional Bathroom',
  'Bonus Room',
  'Family Room',
  'Game Room',
  'Great Room',
  'Loft',
  'Study',
  'Sun Room',
  'Flex',
]

export const garageAlignment_ = ['Garage forward', 'Living forward', 'Aligned']

export const vaultedCeilingLocation = [
  { label: 'Dining', optional: false, value: 'dining' },
  { label: 'Entry', optional: false, value: 'entry' },
  { label: 'Family Room', optional: true, value: 'familyRoom' },
  { label: 'Foyer', optional: false, value: 'foyer' },
  { label: 'Great Room', optional: true, value: 'greatRoom' },
  { label: 'Kitchen', optional: false, value: 'kitchen' },
  { label: 'Living', optional: false, value: 'living' },
  { label: 'Loft', optional: true, value: 'loft' },
  { label: 'Owners Bath', optional: false, value: 'ownersBath' },
  { label: 'Owners Suite', optional: false, value: 'ownersSuite' },
  { label: 'Study', optional: true, value: 'study' },
]

export const optionalStandard = [
  { label: 'Optional', value: 'Optional' },
  { label: 'Standard', value: 'Standard' },
]
